export const environment = {
  production: true,
  serverUrl: 'https://api.wheels.tube/api/v1/',
  socketUrl: 'https://api.wheels.tube/',
};
